import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import components from "./components/ui-kit";
import store from "./store";

Vue.config.productionTip = false;

components.forEach((component) => {
	Vue.component(component.name, component);
});

new Vue({
	router,
	vuetify,
	store,
	render: (h) => h(App),
}).$mount("#app");
